// extracted by mini-css-extract-plugin
module.exports = {"board-col":"icon-column_board-col__3Y5ZV","board-col-line":"icon-column_board-col-line__2xSkp"};